import React from 'react';
export function MenuPreview() {
    return <div>Menu Preview</div>;
}